import {useCallback} from 'react';

import {useDocumentRepository} from '@/components/document/repository';
import {useDocumentUtils} from '@/components/document/utils';
import {DocumentModel} from '@/engine/types/document-model/document-model';
import {getSectionAttachmentIds} from '@/utils/document/attachments';

type Props = {
  formSection: string;
  documentModel: DocumentModel;
  markCurrentSectionAsCleared: () => void;
};

export const useResetCurrentSection = ({formSection, documentModel, markCurrentSectionAsCleared}: Props) => {
  const {store} = useDocumentUtils();
  const {removeDocumentAttachment} = useDocumentRepository();

  return useCallback(async () => {
    const state = store.getState();

    state.clearSection(formSection, documentModel);
    state.unregisterSectionAttachments(formSection);
    markCurrentSectionAsCleared();

    const attachments = getSectionAttachmentIds(state.attachments, formSection);
    await Promise.all(attachments.map(attachmentId => removeDocumentAttachment(attachmentId)));
  }, [formSection, documentModel, markCurrentSectionAsCleared, store, removeDocumentAttachment]);
};
